/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Activity, RefreshCw, FileText, Download, Sparkles, Info, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

export default function Monitoreo() {
  const { user } = useAuth();

  // --- ESTADOS: SNAPSHOTS AWS ---
    const [, setSnapshots] = useState([]);
  const [loadingSnapshots, setLoadingSnapshots] = useState(true);
  
  // --- ESTADOS: REPORTES DE SALUD ---
  const [reportesSalud, setReportesSalud] = useState([]);
  const [loadingSalud, setLoadingSalud] = useState(true);
  const [errorSalud, setErrorSalud] = useState('');
  const [errorSolicitud, setErrorSolicitud] = useState('');
  const reportFetchActive = useRef(false);
  const [generandoSalud, setGenerandoSalud] = useState(false);
  const [descargandoSaludId, setDescargandoSaludId] = useState(null);
  
  // PAGINACIÓN SALUD
  const [paginaActualSalud, setPaginaActualSalud] = useState(1);
  const itemsPorPaginaSalud = 10;
  
  // Formulario Salud
  const [clienteSalud, setClienteSalud] = useState('');
  const [clientesOci, setClientesOci] = useState([]);
  const [errorClientesOci, setErrorClientesOci] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [paramsAdicionales, setParamsAdicionales] = useState('');
  const [todasVms, setTodasVms] = useState(false);
  const metricOptions = [
    { value: 'cpu', label: 'CPU' },
    { value: 'memory', label: 'RAM' },
    { value: 'network', label: 'Red' },
    { value: 'disk', label: 'Discos' },
    { value: 'availability', label: 'Disponibilidad' },
  ];
  const [metricasSeleccionadas, setMetricasSeleccionadas] = useState(metricOptions.map((metric) => metric.value));
  const todasMetricas = metricasSeleccionadas.length === metricOptions.length;

  // Estados UI (Modal y Terminal)
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [terminalLogs, setTerminalLogs] = useState('healthcenter@kloud-pilot:~$ Esperando instrucciones...\n');
  const terminalRef = useRef(null);
  const pollingInterval = useRef(null);

  // --- ESTADOS: REPORTES DRS ---
    const [, setReportesDrs] = useState([]);
  const [loadingDrs, setLoadingDrs] = useState(true);

  const [lastUpdate, setLastUpdate] = useState(new Date().toLocaleTimeString());
  const cardClasses = 'bg-white/5 backdrop-blur-xl border border-white/10 rounded-[2.5rem] p-8 shadow-2xl';

  // LOGOS SVG
  const AwsLogo = () => <img src="https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" alt="AWS" className="h-4" />;
  const AzureLogo = () => <img src="https://upload.wikimedia.org/wikipedia/commons/a/a8/Microsoft_Azure_Logo.svg" alt="Azure" className="h-4" />;
  const GcpLogo = () => <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg" alt="GCP" className="h-4" />;
  const HuaweiLogo = () => (
    <span className="text-xs font-bold text-red-500 uppercase tracking-wider bg-red-500/10 px-2 py-0.5 rounded border border-red-500/30">
        Huawei
    </span>
  );

  useEffect(() => {
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [terminalLogs]);

  // --- LLAMADAS A LA API ---
  useEffect(() => {
    let active = true;
    axios.get('https://healthcenter.kloud-pilot.com/reportes/api/monitoring/clientes-oci/')
      .then(({ data }) => {
        if (!Array.isArray(data.customers) || data.customers.some((name) => typeof name !== 'string')) {
          throw new Error('Catálogo Oracle inválido');
        }
        if (active) setClientesOci(data.customers);
      })
      .catch((error) => {
        console.error('Error clientes Oracle:', error);
        if (active) setErrorClientesOci('No se pudieron cargar los clientes Oracle. Recarga la página para reintentar.');
      });
    return () => { active = false; };
  }, []);

  const fetchSnapshots = async () => {
    setLoadingSnapshots(true);
    try {
      const response = await axios.get('https://healthcenter.kloud-pilot.com/reportes/api/monitoring/snapshots/');
      setSnapshots(response.data.data || response.data);
    } catch (error) { console.error("Error snapshots:", error); } 
    finally { setLoadingSnapshots(false); }
  };

  const toggleTodasMetricas = (checked) => {
    setMetricasSeleccionadas(checked ? metricOptions.map((metric) => metric.value) : []);
  };

  const toggleMetrica = (value) => {
    setMetricasSeleccionadas((prev) => (
      prev.includes(value)
        ? prev.filter((metric) => metric !== value)
        : [...prev, value]
    ));
  };

  const fetchReportesSalud = useCallback(async (background = false) => {
    if (reportFetchActive.current) return;
    reportFetchActive.current = true;
    if (background !== true) setLoadingSalud(true);
    try {
      const response = await axios.get('https://healthcenter.kloud-pilot.com/reportes/api/monitoring/reportes-salud/');
      setReportesSalud(response.data); 
      setErrorSalud('');
    } catch (error) {
      console.error("Error reportes salud:", error);
      setErrorSalud('No se pudo actualizar el estado de los reportes. Se reintentará; también puedes pulsar Actualizar.');
    } finally {
      reportFetchActive.current = false;
      setLoadingSalud(false);
    }
  }, []);

  const ejecutivoPendiente = reportesSalud.some((report) => (
    ['En cola', 'Generando'].includes(report.executive_status)
  ));
  useEffect(() => {
    if (!ejecutivoPendiente) return undefined;
    const interval = setInterval(() => fetchReportesSalud(true), 10000);
    return () => clearInterval(interval);
  }, [ejecutivoPendiente, fetchReportesSalud]);

  const fetchReportesDrs = async () => {
    setLoadingDrs(true);
    try {
      const response = await axios.get('https://healthcenter.kloud-pilot.com/reportes/api/monitoring/reportes-drs/');
      setReportesDrs(response.data); 
    } catch (error) { console.error("Error reportes DRS:", error); } 
    finally { setLoadingDrs(false); }
  };

  // --- LÓGICA DEL REPORTE DE SALUD CON CELERY ---
  const dispararSalud = async (e) => {
    e.preventDefault();
    if (!clienteSalud || !fechaInicio || !fechaFin) return alert("Faltan datos requeridos.");
    setErrorSolicitud('');
    
    setShowWarningModal(true);
    setGenerandoSalud(true);
    setTerminalLogs('healthcenter@kloud-pilot:~$ Esperando instrucciones...\n>> Ejecutando script de extracción...\n');

    try {
      const payload = {
        cliente: clienteSalud,
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin,
        parametros_adicionales: paramsAdicionales,
        todas_vms: todasVms ? "TODAS" : "",
        todas_metricas: todasMetricas ? "all" : "",
        metricas: metricasSeleccionadas
      };

      const response = await axios.post(
        'https://healthcenter.kloud-pilot.com/reportes/api/monitoring/disparar-salud/',
        payload,
        {
          headers: {
            'X-Requested-By': user?.email || user?.name || 'OpsCenter'
          }
        }
      );

      if (response.data.task_id) {
        setTerminalLogs(prev => prev + `>> Conexión con Celery exitosa. ID Tarea: ${response.data.task_id}\n>> Comenzando procesamiento en segundo plano...\n\n`);
        iniciarRadarLogs(response.data.task_id);
      } else {
        setTerminalLogs(prev => prev + `\n<span style="color: #ef4444">>> Error al iniciar: ${response.data.mensaje || 'Respuesta inválida'}</span>\n`);
        setGenerandoSalud(false);
      }
    } catch (error) {
        setErrorSolicitud(error.response?.data?.mensaje || 'No se pudo iniciar el reporte de salud.');
        setTerminalLogs(prev => prev + `\n<span style="color: #ef4444">>> Error de conexión con el servidor.</span>\n`);
        setGenerandoSalud(false); 
    } 
  };

  const iniciarRadarLogs = (taskId) => {
    if (pollingInterval.current) clearInterval(pollingInterval.current);
    
    pollingInterval.current = setInterval(async () => {
        try {
            const response = await axios.get(`https://healthcenter.kloud-pilot.com/reportes/estado_tarea/${taskId}/`);
            const data = response.data;
            
            if (data.log) {
                setTerminalLogs(prev => {
                    const lineas = prev.trim().split('\n');
                    const ultimaLinea = lineas[lineas.length - 1];
                    if (!ultimaLinea.includes(data.log)) {
                        return prev + `[${new Date().toLocaleTimeString()}] ${data.log}\n`;
                    }
                    return prev;
                });
            }

            if (data.estado === 'SUCCESS' || data.estado === 'FAILURE') {
                clearInterval(pollingInterval.current);
                setGenerandoSalud(false);
                
                if (data.estado === 'SUCCESS') {
                    setTerminalLogs(prev => prev + `\n>> Proceso completado exitosamente. Actualizando tabla...\n`);
                    setTimeout(() => {
                        fetchReportesSalud();
                    }, 2000); 
                }
            }
        } catch (error) {
            console.error("Error consultando estado de Celery:", error);
        }
    }, 2000);
  };

  // --- DISPARADORES Y DESCARGAS RESTANTES ---
  const descargarSalud = async (id, version = 'legacy') => {
    setDescargandoSaludId(`${id}:${version}`);
    try {
      const versionPath = version === 'executive' ? 'executive/' : '';
      const response = await axios.get(`https://healthcenter.kloud-pilot.com/reportes/api/monitoring/descargar-salud/${id}/${versionPath}`);
      
      if (response.data.status !== 'success' || !response.data.url) {
        throw new Error(response.data.message || 'El servidor no devolvió un enlace de descarga válido.');
      }

      const link = document.createElement('a');
      link.href = response.data.url;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) { 
      const errorMsg = error.response?.data?.message || error.message || "Error de red al obtener el enlace de descarga.";
      alert(`Error: ${errorMsg}`);
    } finally { 
      setDescargandoSaludId(null); 
    }
  };

  const refreshAll = () => {
    fetchSnapshots();
    fetchReportesSalud();
    fetchReportesDrs();
    setLastUpdate(new Date().toLocaleTimeString());
  };

  useEffect(() => {
    refreshAll();
    const interval = setInterval(refreshAll, 300000);
    return () => {
        clearInterval(interval);
        if (pollingInterval.current) clearInterval(pollingInterval.current);
    };
  }, []);

  // --- LÓGICA PAGINACIÓN SALUD ---
  const indiceUltimoReporte = paginaActualSalud * itemsPorPaginaSalud;
  const indicePrimerReporte = indiceUltimoReporte - itemsPorPaginaSalud;
  const reportesActualesSalud = reportesSalud.slice(indicePrimerReporte, indiceUltimoReporte);
  const totalPaginasSalud = Math.ceil(reportesSalud.length / itemsPorPaginaSalud);

  const cambiarPagina = (numeroPagina) => setPaginaActualSalud(numeroPagina);

  return (
    <div className="min-h-screen bg-[#0a0020] text-white p-8 font-sans relative">
      
      {/* HEADER */}
      <div className="flex justify-between items-center mb-10">
        <div>
          <h1 className="text-4xl font-black tracking-tight bg-gradient-to-r from-[#04d9ff] via-[#00ffb3] to-[#04d9ff] bg-clip-text text-transparent uppercase">
            Reportes de Salud F2F
          </h1>
          <p className="text-xs font-medium tracking-widest uppercase opacity-50 mt-1 flex items-center gap-2">
            <Activity size={12} className="text-[#00ffb3]" /> Monitoreo de infraestructura y reportes automatizados
          </p> 
        </div>
        
        <div className="flex items-center gap-4">
          <div className="text-right">
            <p className="text-[10px] opacity-40 uppercase font-bold tracking-tighter">Última sincronización</p>
            <p className="text-sm font-mono text-[#00ffb3]">{lastUpdate}</p>
          </div>
          <button onClick={refreshAll} className="p-4 bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl transition-all">
            <RefreshCw size={20} className={`${loadingSnapshots || loadingSalud || loadingDrs ? 'animate-spin' : ''}`} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-8">
        
        {/* SECCIÓN 1: REPORTES DE SALUD */}
        <div className={cardClasses}>
          
          <form onSubmit={dispararSalud} className="p-6 bg-white/5 border border-white/10 rounded-3xl mb-8">
            {/* Tooltip de Información */}
            <div className="flex items-center gap-2 mb-6 relative group w-fit">
                <h3 className="text-white font-bold text-lg">Opciones de Reporte</h3>
                <div className="text-gray-400 hover:text-[#04d9ff] cursor-help transition duration-200">
                    <Info size={18} />
                </div>
                {/* Menú Flotante */}
                <div className="absolute left-0 top-full mt-2 w-80 p-4 bg-[#1e1e1e] border border-white/10 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                    <p className="text-sm font-bold text-white mb-2 border-b border-white/10 pb-2">¿Cómo funciona?</p>
                    <ul className="text-xs text-gray-300 space-y-3 mt-3">
                        <li className="flex items-start gap-2">
                            <span className="text-[#04d9ff] mt-0.5">🌍</span>
                            <p><strong className="text-[#04d9ff]">Reporte Global:</strong> Se genera si dejas el cuadro de texto vacío y no marcas la casilla. Solo usa el Cliente y las Fechas.</p>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-purple-400 mt-0.5">🎯</span>
                            <p><strong className="text-purple-300">Reporte Detallado:</strong> Se activa automáticamente si escribes los nombres de las VMs o si marcas la casilla <em>"Seleccionar TODAS las VMs"</em>.</p>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Fila 1: Selectores Clave */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="flex flex-col">
                    <label className="text-[10px] text-gray-400 font-bold mb-2 uppercase tracking-widest">Cliente</label>
                    <select aria-label="Cliente del reporte" required value={clienteSalud} onChange={(e) => setClienteSalud(e.target.value)} className="bg-[#0a0020] border border-white/20 text-white rounded-xl p-3 text-sm focus:outline-none focus:border-[#04d9ff] transition cursor-pointer">
                        <option value="" disabled hidden>Selecciona un cliente</option>
                        <optgroup label="Entorno AWS">
                            <option value="Odessa">Odessa</option>
                            <option value="Fonacot">Fonacot</option>
                            <option value="OneCore">OneCore</option>
                            <option value="Freyman">Freyman</option>
                            <option value="SpaceAduanas">Space Aduanas</option>
                            <option value="EditorialEsfinge">Editorial Esfinge</option>
                            <option value="Basa">Basa</option>
                        </optgroup>
                        <optgroup label="Entorno Azure">
                            <option value="Elementia">Elementia</option>
                            <option value="Fultra">Fultra</option>
                            <option value="Imbera">Imbera</option>
                            <option value="Artigraf">Artigraf</option>
                            <option value="BB&Asociados">BB&Asociados</option>
                            <option value="GeniusSoft">GeniusSoft</option>
                            <option value="Alica">Alica</option>
                            <option value="Pacific Global (DX IA)">Pacific Global (DX IA)</option>
                        </optgroup>
                        <optgroup label="Entorno GCP">
                            <option value="izzi">Izzi</option>
                            <option value="sportsworld">Sports World</option>
                            <option value="flyacross">FlyAcross</option>
                        </optgroup>
                        <optgroup label="Entorno Huawei">
                            <option value="Automatica">Automatica</option>
                            <option value="Club de Golf">Club de Golf</option>
                            <option value="JB Solutions">JB Solutions</option>
                            <option value="Fibra Hotelera">Fibra Hotelera</option>
                        </optgroup>
                        <optgroup label="Entorno Oracle Cloud (OCI)">
                            {clientesOci.map((cliente) => <option key={cliente} value={cliente}>{cliente}</option>)}
                        </optgroup>
                    </select>
                    {errorClientesOci && <p role="alert" className="text-sm text-red-400 mt-2">{errorClientesOci}</p>}
                </div>
                <div className="flex flex-col">
                    <label htmlFor="salud-fecha-inicio" className="text-[10px] text-gray-400 font-bold mb-2 uppercase tracking-widest">Fecha Inicio</label>
                    <input id="salud-fecha-inicio" required type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} className="bg-[#0a0020] border border-white/20 text-white rounded-xl p-3 text-sm focus:outline-none focus:border-[#04d9ff] transition cursor-pointer" style={{colorScheme:'dark'}}/>
                </div>
                <div className="flex flex-col">
                    <label htmlFor="salud-fecha-fin" className="text-[10px] text-gray-400 font-bold mb-2 uppercase tracking-widest">Fecha Fin</label>
                    <input id="salud-fecha-fin" required type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} className="bg-[#0a0020] border border-white/20 text-white rounded-xl p-3 text-sm focus:outline-none focus:border-[#04d9ff] transition cursor-pointer" style={{colorScheme:'dark'}}/>
                </div>
            </div>

            {/* Fila 2: Textarea y Checkbox */}
            <div className="w-full flex flex-col gap-2 mb-6">
                <div className="flex justify-between items-center mb-1">
                    <label className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">
                        Parámetros adicionales para reporte detallado
                    </label>
                    <label className="flex items-center gap-2 text-[10px] cursor-pointer group transition uppercase font-bold">
                        <input type="checkbox" checked={todasVms} onChange={(e) => setTodasVms(e.target.checked)} className="w-3.5 h-3.5 rounded bg-transparent border-gray-500 accent-[#04d9ff] cursor-pointer" />
                        <span className="text-white group-hover:text-[#04d9ff] transition-colors">Seleccionar TODAS las VMs</span>
                    </label>
                </div>
                <textarea
                    value={paramsAdicionales}
                    onChange={(e) => setParamsAdicionales(e.target.value)}
                    disabled={todasVms}
                    rows="3"
                    placeholder="Ejemplo: VM1,VM2,VM3... (Dejar en blanco si se marca la casilla superior)"
                    className="bg-[#0a0020] border border-white/20 text-gray-300 text-sm rounded-xl focus:ring-[#04d9ff] focus:border-[#04d9ff] w-full p-3 outline-none transition resize-y disabled:opacity-30 disabled:cursor-not-allowed"
                ></textarea>
            </div>

            {/* Fila 3: Métricas */}
            <div className="bg-[#0a0020]/60 border border-white/10 rounded-2xl p-4 mb-6">
                <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                    <div>
                        <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Métricas a recolectar</p>
                        <p className="text-xs text-gray-500 mt-1">Aplica para AWS, Azure, GCP, Huawei y Oracle (OCI). CPU también se consulta para el resumen global. Las otras métricas no seleccionadas no se consultan ni se dibujan.</p>
                        <p className="text-xs text-gray-500 mt-1">Oracle: últimos 90 días, resolución horaria y fechas UTC. RAM y discos requieren telemetría del agente; los días futuros no se rellenan.</p>
                    </div>
                    <label className="flex items-center gap-2 text-xs text-white cursor-pointer">
                        <input
                            type="checkbox"
                            checked={todasMetricas}
                            onChange={(e) => toggleTodasMetricas(e.target.checked)}
                            className="w-3.5 h-3.5 rounded bg-transparent border-gray-500 accent-[#04d9ff] cursor-pointer"
                        />
                        <span className="font-bold text-[#04d9ff]">Todas las métricas</span>
                    </label>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                    {metricOptions.map((metric) => (
                        <label key={metric.value} className="flex items-center gap-2 text-sm text-gray-300 cursor-pointer hover:text-white transition">
                            <input
                                type="checkbox"
                                checked={metricasSeleccionadas.includes(metric.value)}
                                onChange={() => toggleMetrica(metric.value)}
                                className="w-3.5 h-3.5 rounded bg-transparent border-gray-500 accent-[#04d9ff] cursor-pointer"
                            />
                            <span>{metric.label}</span>
                        </label>
                    ))}
                </div>
            </div>

            {/* Fila 4: Submit */}
            {errorSolicitud && <p role="alert" className="text-sm text-red-400 mb-3">{errorSolicitud}</p>}
            <div className="flex justify-end">
                <button type="submit" disabled={generandoSalud} className="bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold py-3 px-6 rounded-xl flex items-center gap-2 transition duration-200 disabled:opacity-50 text-sm">
                    {generandoSalud ? <RefreshCw size={18} className="animate-spin" /> : <FileText size={18} />} Generar Reporte de Salud
                </button>
            </div>
          </form>

          {/* LA TERMINAL ESTILO MAC */}
          <div className="mb-10">
              <div className="bg-[#1e1e1e] w-full rounded-2xl shadow-2xl overflow-hidden border border-white/10">
                  <div className="bg-[#2d2d2d] px-4 py-3 flex items-center justify-between border-b border-black">
                      <div className="flex gap-2">
                          <div className="w-3 h-3 rounded-full bg-red-500"></div>
                          <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                          <div className="w-3 h-3 rounded-full bg-green-500"></div>
                      </div>
                      <div className="text-xs text-gray-400 font-mono tracking-wider">celery@healthcenter ~ /monitoreo-vivo</div>
                      <div className="w-10"></div>
                  </div>
                  <div 
                      ref={terminalRef} 
                      className="p-6 h-64 overflow-y-auto bg-black text-[#00ffb3] font-mono text-sm leading-relaxed whitespace-pre-line"
                      dangerouslySetInnerHTML={{ __html: terminalLogs }} 
                  />
              </div>
          </div>

          {/* TABLA PRINCIPAL AL ESTILO HTML/DJANGO */}
          <div className="flex justify-between items-center mb-6 mt-12">
            <h3 className="text-xl font-bold text-white tracking-wide">Reportes de salud disponibles</h3>
            <button onClick={fetchReportesSalud} className="bg-[#0078D4] hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2 transition duration-200 shadow-lg text-sm">
                <RefreshCw size={16} className={`${loadingSalud ? 'animate-spin' : ''}`} /> Actualizar tabla de reportes
            </button>
          </div>

          {errorSalud && <p role="alert" className="text-sm text-red-400 mb-3">{errorSalud}</p>}
          <div className="bg-[#18181b] rounded-xl border border-gray-700 overflow-hidden shadow-2xl">
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-[#27272a] border-b border-gray-700">
                            <th className="p-4 text-xs font-semibold uppercase text-gray-400 tracking-wider">Cliente / Proveedor</th>
                            <th className="p-4 text-xs font-semibold uppercase text-gray-400 tracking-wider">Tipo</th>
                            <th className="p-4 text-xs font-semibold uppercase text-gray-400 tracking-wider">Rangos de Fecha</th>
                            <th className="p-4 text-xs font-semibold uppercase text-gray-400 tracking-wider">Fecha de Creación</th>
                            <th className="p-4 text-xs font-semibold uppercase text-gray-400 tracking-wider">Generado por</th>
                            <th className="p-4 text-xs font-semibold uppercase text-gray-400 tracking-wider">Tiempo de ejecución</th>
                            <th className="p-4 text-xs font-semibold uppercase text-gray-400 tracking-wider">Status</th>
                            <th className="p-4 text-xs font-semibold uppercase text-gray-400 tracking-wider">Opciones</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700">
                        {reportesActualesSalud.map((r, i) => (
                            <tr key={r.id || i} className="hover:bg-zinc-800/50 transition">
                                {/* Cliente y Proveedor con Logos */}
                                <td className="p-4">
                                    <div className="font-bold text-[#04d9ff] text-sm">{r.cliente}</div>
                                    <div className="flex items-center gap-2 mt-1.5">
                                        {r.proveedor?.toLowerCase() === 'aws' ? <AwsLogo /> :
                                         r.proveedor?.toLowerCase() === 'azure' ? <AzureLogo /> :
                                         r.proveedor?.toLowerCase() === 'gcp' ? <GcpLogo /> :
                                         r.proveedor?.toLowerCase() === 'huawei' ? <HuaweiLogo /> :
                                         <span className="text-xs text-gray-400 uppercase">{r.proveedor}</span>}
                                    </div>
                                </td>
                                
                                {/* Tipo de Reporte (Etiquetas con color) */}
                                <td className="p-4 text-sm">
                                    {r.report_type === 'Detallado' || r.tipo === 'Detallado' ? (
                                        <span className="bg-purple-900/40 text-purple-300 py-1 px-2.5 rounded border border-purple-700 text-xs font-semibold tracking-wide">
                                            🎯 Detallado
                                        </span>
                                    ) : (
                                        <span className="bg-blue-900/40 text-blue-300 py-1 px-2.5 rounded border border-blue-700 text-xs font-semibold tracking-wide">
                                            🌍 Global
                                        </span>
                                    )}
                                </td>

                                {/* Rango de fechas */}
                                <td className="p-4 text-gray-300 text-sm font-mono">
                                    {r.fecha_inicio} - {r.fecha_fin}
                                </td>
                                
                                {/* Fecha de Creación */}
                                <td className="p-4 text-gray-300 text-sm font-mono">
                                    {r.timestamp}
                                </td>

                                {/* Generado por */}
                                <td className="p-4 text-gray-300 text-xs">
                                    {r.generated_by || <span className="text-gray-500">-</span>}
                                </td>

                                {/* Tiempo de ejecución */}
                                <td className="p-4 text-gray-300 text-sm font-mono">
                                    {r.execution_time || <span className="text-gray-500">-</span>}
                                </td>
                                
                                {/* Status */}
                                <td className="p-4">
                                    {r.status === 'Completado' ? (
                                        <span className="flex items-center gap-1.5 text-green-400 text-sm">
                                            <span className="w-2 h-2 bg-green-500 rounded-full"></span> Completado
                                        </span>
                                    ) : r.status === 'En progreso' ? (
                                        <span className="flex items-center gap-1.5 text-yellow-400 text-sm">
                                            <span className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></span> En progreso
                                        </span>
                                    ) : (
                                        <span className="text-red-500 text-sm">{r.status}</span>
                                    )}
                                </td>
                                
                                {/* Opciones */}
                                <td className="p-4 text-sm">
                                    {r.status === 'Completado' ? (
                                        <div className="flex flex-col items-start gap-2">
                                            <button onClick={() => descargarSalud(r.id)} disabled={descargandoSaludId !== null} className="text-blue-400 hover:text-blue-300 font-semibold transition flex items-center gap-1 text-left disabled:opacity-50 disabled:cursor-not-allowed">
                                                {descargandoSaludId === `${r.id}:legacy` ? <RefreshCw size={16} className="shrink-0 animate-spin" /> : <Download size={16} className="shrink-0" />} Reporte tradicional
                                            </button>
                                            {r.executive_available ? (
                                                <button onClick={() => descargarSalud(r.id, 'executive')} disabled={descargandoSaludId !== null} className="text-purple-300 hover:text-purple-200 font-semibold transition flex items-center gap-1 text-left disabled:opacity-50 disabled:cursor-not-allowed">
                                                    {descargandoSaludId === `${r.id}:executive` ? <RefreshCw size={16} className="shrink-0 animate-spin" /> : <Sparkles size={16} className="shrink-0" />} Reporte ejecutivo IA
                                                </button>
                                            ) : r.executive_status === 'Error' ? (
                                                <span className="text-xs text-red-400">Error en Reporte Ejecutivo IA</span>
                                            ) : ['En cola', 'Generando'].includes(r.executive_status) ? (
                                                <span role="status" className="text-xs text-purple-300 flex items-center gap-1">
                                                    <RefreshCw size={14} className="animate-spin" /> Generando Reporte Ejecutivo IA…
                                                </span>
                                            ) : null}
                                        </div>
                                    ) : (
                                        <span className="text-gray-500 cursor-not-allowed">Procesando...</span>
                                    )}
                                </td>
                            </tr>
                        ))}

                        {reportesSalud.length === 0 && !loadingSalud && (
                            <tr>
                                <td colSpan="8" className="p-8 text-center text-gray-500 italic">
                                    No hay reportes de salud generados aún.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
          </div>

          {/* CONTROLES DE PAGINACIÓN */}
          {reportesSalud.length > 0 && (
            <div className="flex justify-center items-center gap-2 mt-6">
                <button 
                    onClick={() => cambiarPagina(1)} 
                    disabled={paginaActualSalud === 1}
                    className="px-3 py-2 bg-zinc-700 rounded hover:bg-zinc-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                >
                    <ChevronsLeft size={16} />
                </button>
                <button 
                    onClick={() => cambiarPagina(paginaActualSalud - 1)} 
                    disabled={paginaActualSalud === 1}
                    className="px-3 py-2 bg-zinc-700 rounded hover:bg-zinc-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                >
                    <ChevronLeft size={16} />
                </button>

                <div className="flex gap-1">
                    {[...Array(totalPaginasSalud)].map((_, idx) => {
                        const num = idx + 1;
                        // Mostrar solo 2 números hacia atrás y 2 hacia adelante (como en tu Django)
                        if (num >= paginaActualSalud - 2 && num <= paginaActualSalud + 2) {
                            return (
                                <button
                                    key={num}
                                    onClick={() => cambiarPagina(num)}
                                    className={`px-4 py-2 rounded transition font-bold ${
                                        paginaActualSalud === num 
                                        ? "bg-blue-600 text-white" 
                                        : "bg-zinc-700 text-white hover:bg-zinc-600"
                                    }`}
                                >
                                    {num}
                                </button>
                            );
                        }
                        return null;
                    })}
                </div>

                <button 
                    onClick={() => cambiarPagina(paginaActualSalud + 1)} 
                    disabled={paginaActualSalud === totalPaginasSalud}
                    className="px-3 py-2 bg-zinc-700 rounded hover:bg-zinc-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                >
                    <ChevronRight size={16} />
                </button>
                <button 
                    onClick={() => cambiarPagina(totalPaginasSalud)} 
                    disabled={paginaActualSalud === totalPaginasSalud}
                    className="px-3 py-2 bg-zinc-700 rounded hover:bg-zinc-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                >
                    <ChevronsRight size={16} />
                </button>
            </div>
          )}

        </div>

        {/* SECCIÓN 2: REPORTES DRS & SNAPSHOTS (Mismo código de antes...) */}
        {/* ... */}
        
      </div>

      {/* EL MODAL DE ADVERTENCIA */}
      {showWarningModal && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center transition-opacity duration-300">
            <div className="bg-[#0a0020] border border-white/10 p-8 rounded-3xl shadow-2xl max-w-md w-full text-center relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1.5 bg-amber-500"></div>
                <div className="text-amber-500 mb-5 flex justify-center">
                    <Activity size={64} className="animate-pulse" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">Reporte Iniciado</h3>
                <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                    Tiempos estimados: <strong>Al menos 5 minutos para reportes detallados y 15 minutos para globales</strong>.
                    <br/><br/>
                    <span className="text-red-400 font-semibold">⚠️ Por favor, NO generes otro reporte hasta que este termine.</span> Si encolas múltiples reportes al mismo tiempo, el servidor podría bloquearse.
                </p>
                <button onClick={() => setShowWarningModal(false)} className="bg-[#04d9ff]/20 hover:bg-[#04d9ff]/30 border border-[#04d9ff]/50 text-[#04d9ff] px-8 py-3 rounded-xl font-bold w-full transition shadow-lg">
                    Entendido, esperaré.
                </button>
            </div>
        </div>
      )}

    </div>
  );
}